import { storage } from './firebase';

export const doUploadUserPhoto = (file, userId) => {
  if (!file || !userId) {
    throw new Error('File and userId are required');
  }
  return storage.ref('/uploads').child(`${userId}`).putString(file, 'data_url');
};

export const doUserPhotoUrlLink = async (userId) => {
  if (!userId) {
    console.error('UserId is required to fetch photo');
    return null;
  }

  try {
    // Log para debug em produção
    if (process.env.NODE_ENV === 'production') {
      console.log(`Tentando buscar foto do usuário ${userId}`);
    }

    const photoRef = storage.ref(`/uploads/${userId}`);

    // Log do path completo em produção
    if (process.env.NODE_ENV === 'production') {
      console.log('Firebase Storage path:', photoRef.fullPath);
    }

    const url = await photoRef.getDownloadURL();
    return url;
  } catch (error) {
    // Log detalhado do erro em produção
    if (process.env.NODE_ENV === 'production') {
      console.error(`Erro ao buscar foto do usuário ${userId}:`, {
        code: error.code,
        message: error.message,
        storagePath: `/uploads/${userId}`
      });
    }
    throw error;
  }
};

export const doRemoveUserPhoto = (userId) => {
  if (!userId) {
    throw new Error('UserId is required to remove photo');
  }
  return storage.ref(`/uploads/${userId}`).delete();
};
